import { Link as RouterLink } from 'react-router-dom';
import makeThemedComponent from '../../utils/makeThemedComponent';
import { defaultStyles } from '../Link';
/**
 * Renders a React Router [Link](https://reacttraining.com/react-router/web/api/Link).
 *
 * @public
 * @author Connor Taylor
 */

var NavLink = makeThemedComponent({
  themeKey: "Link",
  displayName: "NavLink",
  component: RouterLink,
  defaultStyles: defaultStyles
});
NavLink.defaultProps = {
  to: "/"
};
export { defaultStyles };
/** @component */

export default NavLink;